import { alpha, Box, Modal, Stack, Typography, useColorScheme } from "@mui/material";
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { MainInput, MainButton, DefaultButton, ErrorButton } from "../index";
import { Constants } from "../../utils/constants";
import { useEffect, useState } from "react";

export default function ProjectDeleteModal({
    open,
    onClose,
    project,
    onFinish,
}) {
    const { mode } = useColorScheme();
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        minWidth: 300,
        maxWidth: 450,
        bgcolor: 'background.paper',
        border: `1px solid ${Constants.Colors[mode].border}`,
        borderRadius: "8px",
        boxShadow: 24,
        p: "1.5rem",
    };

    useEffect(() => {
    }, [open]);

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-project-create-title"
            aria-describedby="modal-project-create-description"
        >
            <Box sx={style}>
                <Stack
                    spacing={"1.25rem"}
                    direction={"column"}
                    alignItems={"center"}
                    justifyContent={"center"}
                >
                    <ErrorOutlineOutlinedIcon sx={{
                        color: Constants.Colors[mode].warning,
                        fontSize: 64,
                    }} />
                    <Typography variant="h6" align="center">
                        {`Are you sure you want to delete project\n\n "${project?.name}"?`}
                    </Typography>
                    <Stack direction={"row"}
                        alignItems={"center"}
                        justifyContent={"center"}
                        spacing={2}
                    >
                        <DefaultButton
                            text={"Cancel"}
                            onClick={onClose}
                            size="medium"
                        />
                        <ErrorButton
                            text={"Delete"}
                            onClick={() => {
                                onFinish(project);
                            }}
                            size="medium"
                        />
                    </Stack>


                </Stack>
            </Box>
        </Modal>
    );
}